import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Modal from "@mui/material/Modal";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

type TagEditorProps = {
  open: boolean;
  tagInput: string;
  tags: string[];
  onOpen: () => void;
  onClose: () => void;
  onTagInputChange: (value: string) => void;
  onAddTag: () => void;
  onRemoveTag: (tag: string) => void;
};

export function TagEditor({
  open,
  tagInput,
  tags,
  onOpen,
  onClose,
  onTagInputChange,
  onAddTag,
  onRemoveTag,
}: TagEditorProps) {
  return (
    <>
      <Stack direction="row" sx={{ flexWrap: "wrap", gap: 1, mb: 2 }}>
        {tags.map((tag) => (
          <Chip
            key={tag}
            label={tag}
            onDelete={() => onRemoveTag(tag)}
            sx={tagChipSx}
          />
        ))}
        <Button type="button" variant="outlined" onClick={onOpen}>
          Tags
        </Button>
      </Stack>

      <Modal open={open} onClose={onClose}>
        <Box sx={modalSx}>
          <Typography variant="h6" component="h3" sx={{ mb: 2, color: "white" }}>
            Tags
          </Typography>

          <Stack direction="row" sx={{ flexWrap: "wrap", gap: 1, mb: 2 }}>
            {tags.map((tag) => (
              <Chip
                key={tag}
                label={tag}
                onDelete={() => onRemoveTag(tag)}
                sx={tagChipSx}
              />
            ))}
          </Stack>

          <Stack sx={{ gap: 2 }}>
            <Stack direction="row" sx={{ gap: 1 }}>
              <TextField
                label="Tag"
                value={tagInput}
                onChange={(event) => onTagInputChange(event.target.value)}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                    onAddTag();
                  }
                }}
                fullWidth
                sx={textFieldSx}
              />
              <Button variant="contained" onClick={onAddTag}>
                Add
              </Button>
            </Stack>

            <Stack direction="row" sx={{ justifyContent: "flex-end" }}>
              <Button onClick={onClose}>Done</Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </>
  );
}

const modalSx = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "min(520px, calc(100vw - 32px))",
  bgcolor: "#16171d",
  border: "1px solid #2e303a",
  borderRadius: 2,
  boxShadow: 24,
  color: "white",
  p: 3,
};

const tagChipSx = {
  color: "white",
  borderColor: "rgba(192, 132, 252, 0.5)",
  backgroundColor: "rgba(192, 132, 252, 0.15)",
};

const textFieldSx = {
  "& .MuiInputBase-input": {
    color: "white",
  },
  "& .MuiInputLabel-root": {
    color: "rgba(255, 255, 255, 0.7)",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255, 255, 255, 0.3)",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "rgba(255, 255, 255, 0.55)",
  },
};
